import type { FC } from "react";
import { createBrowserRouter, RouterProvider } from "react-router";

import type { AppRouterProps } from "../types/AppRouterProps";

export interface AppProps {
    router: AppRouterProps;
}

export const AppRouter: FC<AppProps> = ({ router }) => {
    const { routes } = router;

    const browserRouter = createBrowserRouter(routes);
    return <RouterProvider router={browserRouter} />;
};
